import type Translator from '../../../services/translate-factory';
import { Language } from '../../../services/translate-factory';
import type { TermType } from '../../../store/constants/general';

type ExcelLanguageFileName = {
  dir: string;
  language: Language;
  termType?: TermType;
};

export function setExcelTemplateDir(
  T: Translator,
  excelFiles: ExcelLanguageFileName[],
  termType?: TermType,
): string | undefined {
  let languageExcelDir: string | undefined;

  const selectedLanguage = T.getSelectedLanguage();

  for (const file of excelFiles) {
    if (
      file.language === selectedLanguage &&
      (termType === undefined || termType === file.termType)
    ) {
      languageExcelDir = file.dir;
      break;
    }
  }

  if (!languageExcelDir) {
    languageExcelDir = excelFiles.filter((i) => (i.language = Language.TR))[0].dir;
  }

  return languageExcelDir;
}
